export const pagesWithThreeMrects = [
  'car-buying',
  'car-leasing',
  'car-safety',
  'car-loan',
  'car-care',
  'fuel-economy',
  'auto-insurance',
  'car-technology',
  'driving-tips',
  'how-to',
  'car-maintenance',
];

export const pagesWithMobileNativeVideoAd = ['car-buying', 'car-leasing', 'sell-car', 'car-maintenance', 'research'];
